document.addEventListener("DOMContentLoaded", function() {

  // Existing progress bar code
  document.querySelectorAll(".progress-fill").forEach(function(el) {
    const width = el.style.width;
    el.style.width = "0%";
    setTimeout(() => {
      el.style.width = width;
    }, 100);
  });

});

function initDonationInput() {
  const input = document.querySelector(".Givonate-Widget-input input[type='number']");
  if (!input) return;

  // Force integer step
  input.setAttribute("step", "1");

  // Prevent decimals and other invalid chars
  input.addEventListener("keydown", function(e) {
    if ([".", ",", "e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  });

  input.addEventListener("paste", function(e) {
    const pasted = (e.clipboardData || window.clipboardData).getData("text");
    if (/[.,eE+-]/.test(pasted)) {
      e.preventDefault();
    }
  });

  // Track whether the user is overwriting a preset
  let manualEdit = false;

  input.addEventListener("focus", function() {
    manualEdit = false; // reset when focusing
  });

  input.addEventListener("keydown", function(e) {
    // If user presses a number key, mark as manual edit
    if (/^\d$/.test(e.key)) {
      if (!manualEdit) {
        // First digit typed → replace the whole value
        input.value = "";
        manualEdit = true;
      }
    }
  });

  input.addEventListener("input", function(e) {
    const digits = e.target.value.replace(/\D/g, "");
    e.target.value = digits ? parseInt(digits, 10) : "";
  });
}

// Run once on DOM ready
document.addEventListener("DOMContentLoaded", initDonationInput);

// Run again whenever Shopify re-renders sections
window.addEventListener("pageshow", initDonationInput);
document.addEventListener("shopify:section:load", initDonationInput);